var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/pluralize/pluralize.js
var require_pluralize = __commonJS({
  "../../node_modules/pluralize/pluralize.js"(exports, module2) {
    (function(root, pluralize2) {
      if (typeof require === "function" && typeof exports === "object" && typeof module2 === "object") {
        module2.exports = pluralize2();
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return pluralize2();
        });
      } else {
        root.pluralize = pluralize2();
      }
    })(exports, function() {
      var pluralRules = [];
      var singularRules = [];
      var uncountables = {};
      var irregularPlurals = {};
      var irregularSingles = {};
      function sanitizeRule(rule) {
        if (typeof rule === "string") {
          return new RegExp("^" + rule + "$", "i");
        }
        return rule;
      }
      function restoreCase(word, token) {
        if (word === token)
          return token;
        if (word === word.toLowerCase())
          return token.toLowerCase();
        if (word === word.toUpperCase())
          return token.toUpperCase();
        if (word[0] === word[0].toUpperCase()) {
          return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        }
        return token.toLowerCase();
      }
      function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
          return args[index] || "";
        });
      }
      function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
          var result = interpolate(rule[1], arguments);
          if (match === "") {
            return restoreCase(word[index - 1], result);
          }
          return restoreCase(match, result);
        });
      }
      function sanitizeWord(token, word, rules) {
        if (!token.length || uncountables.hasOwnProperty(token)) {
          return word;
        }
        var len = rules.length;
        while (len--) {
          var rule = rules[len];
          if (rule[0].test(word))
            return replace(word, rule);
        }
        return word;
      }
      function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
          var token = word.toLowerCase();
          if (keepMap.hasOwnProperty(token)) {
            return restoreCase(word, token);
          }
          if (replaceMap.hasOwnProperty(token)) {
            return restoreCase(word, replaceMap[token]);
          }
          return sanitizeWord(token, word, rules);
        };
      }
      function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
          var token = word.toLowerCase();
          if (keepMap.hasOwnProperty(token))
            return true;
          if (replaceMap.hasOwnProperty(token))
            return false;
          return sanitizeWord(token, token, rules) === token;
        };
      }
      function pluralize2(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize2.singular(word) : pluralize2.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
      }
      pluralize2.plural = replaceWord(
        irregularSingles,
        irregularPlurals,
        pluralRules
      );
      pluralize2.isPlural = checkWord(
        irregularSingles,
        irregularPlurals,
        pluralRules
      );
      pluralize2.singular = replaceWord(
        irregularPlurals,
        irregularSingles,
        singularRules
      );
      pluralize2.isSingular = checkWord(
        irregularPlurals,
        irregularSingles,
        singularRules
      );
      pluralize2.addPluralRule = function(rule, replacement) {
        pluralRules.push([sanitizeRule(rule), replacement]);
      };
      pluralize2.addSingularRule = function(rule, replacement) {
        singularRules.push([sanitizeRule(rule), replacement]);
      };
      pluralize2.addUncountableRule = function(word) {
        if (typeof word === "string") {
          uncountables[word.toLowerCase()] = true;
          return;
        }
        pluralize2.addPluralRule(word, "$0");
        pluralize2.addSingularRule(word, "$0");
      };
      pluralize2.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
      };
      [
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        ["genus", "genera"],
        ["viscus", "viscera"],
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(rule) {
        return pluralize2.addIrregularRule(rule[0], rule[1]);
      });
      [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(rule) {
        return pluralize2.addPluralRule(rule[0], rule[1]);
      });
      [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(rule) {
        return pluralize2.addSingularRule(rule[0], rule[1]);
      });
      [
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
      ].forEach(pluralize2.addUncountableRule);
      return pluralize2;
    });
  }
});

// src/index.js
var src_exports = {};
__export(src_exports, {
  AccountMenu: () => AccountMenu_default,
  AccountMenuContent: () => AccountMenuContent,
  AccountMenuItem: () => AccountMenuItem_default,
  AccountMenuTrigger: () => AccountMenuTrigger,
  BannerIcon: () => BannerIcon_default,
  BeaconLink: () => BeaconLink_default,
  CallToActions: () => CallToActions,
  CaretIcon: () => CaretIcon,
  Counter: () => Counter,
  Divider: () => Divider,
  GearIcon: () => GearIcon,
  Group: () => Group,
  Header: () => Header,
  HelpMenu: () => HelpMenu_default,
  IconWrapper: () => IconWrapper,
  InstallButton: () => InstallButton_default,
  InstallWrapper: () => InstallWrapper,
  ItemIcon: () => ItemIcon,
  ItemLink: () => ItemLink,
  Links: () => Links,
  Logo: () => import_legacy_components16.Logo,
  NavBeaconLink: () => NavBeaconLink,
  NavItem: () => NavItem_default,
  NavItemWrapper: () => NavItemWrapper,
  PopoverHelpMenu: () => PopoverHelpMenu_default,
  ProgressBarWrapper: () => ProgressBarWrapper,
  Scrollable: () => Scrollable,
  SpoofBanner: () => SpoofBanner_default,
  SpoofControl: () => SpoofControl_default,
  SpoofForm: () => SpoofForm,
  SpoofFormField: () => SpoofFormField,
  TooltipLabel: () => TooltipLabel,
  TrialByDaysWrapper: () => TrialByDaysWrapper,
  TrialMessage: () => TrialMessage,
  TrialMeterByDays: () => TrialMeterByDays_default,
  TrialWrapper: () => TrialWrapper,
  UpsellNavItem: () => UpsellNavItem,
  Wrapper: () => Wrapper
});
module.exports = __toCommonJS(src_exports);

// src/AccountMenu.js
var import_react6 = __toESM(require("react"));
var import_prop_types4 = __toESM(require("prop-types"));
var import_legacy_components3 = require("@studio/legacy-components");

// src/hooks/use-toggle.js
var import_react = require("react");
function useToggle(initialValue = false) {
  const [value, setValue] = (0, import_react.useState)(initialValue);
  const toggle = () => setValue((val) => !val);
  return [value, toggle];
}

// src/AccountMenuButton.js
var import_react5 = __toESM(require("react"));
var import_prop_types3 = __toESM(require("prop-types"));
var import_legacy_components2 = require("@studio/legacy-components");

// src/styled.js
var import_styled_components4 = __toESM(require("styled-components"));
var import_react_separator = require("@radix-ui/react-separator");
var import_legacy_components = require("@studio/legacy-components");
var import_sonar2 = require("@appcues/sonar");

// src/beacon-link/BeaconLink.js
var import_react3 = __toESM(require("react"));
var import_prop_types = __toESM(require("prop-types"));

// src/beacon-link/TypeformPopup.js
var import_react2 = __toESM(require("react"));
var import_styled_components2 = __toESM(require("styled-components"));
var import_embed = require("@typeform/embed");

// src/beacon-link/BeaconLink.styled.js
var import_styled_components = __toESM(require("styled-components"));
var import_sonar = require("@appcues/sonar");
var BeaconTrigger = (0, import_styled_components.default)(import_sonar.Link)`
  --link-text-decoration: none;
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);

  ${({ $light }) => $light && import_styled_components.css`
      color: var(--white);
      font-weight: var(--bold);
      text-decoration: underline;

      &:hover {
        color: var(--text-tertiary);
      }
    `};
`;

// src/beacon-link/TypeformPopup.js
var emptyEmbed = {
  unmount: () => {
  },
  open: () => {
  }
};
var DEFAULT_FORM = "QD5X3rU2";
var TypeformPopup = ({
  id = DEFAULT_FORM,
  "data-testid": dataTestid,
  children,
  as = "span",
  style = {},
  className = "",
  childProps,
  size = 60,
  hiddenFormValues = {},
  ...typeFormOptions
}) => {
  const typeformRef = (0, import_react2.useRef)(emptyEmbed);
  (0, import_react2.useEffect)(() => {
    const typeformOptions = {
      size,
      hidden: hiddenFormValues,
      ...typeFormOptions
    };
    typeformRef.current = (0, import_embed.createPopup)(id, typeformOptions);
  }, [id, typeFormOptions, typeformRef, size, hiddenFormValues]);
  const handleClick = (0, import_react2.useCallback)(
    () => typeformRef.current.open(),
    [typeformRef]
  );
  const triggerElement = import_react2.default.createElement(
    as,
    {
      style,
      onClick: handleClick,
      "data-testid": `tf-v1-popup`
    },
    /* @__PURE__ */ import_react2.default.createElement(BeaconTrigger, {
      className,
      "data-testid": dataTestid,
      icon: false,
      ...childProps
    }, children)
  );
  return triggerElement;
};
var TypeformPopup_default = (0, import_styled_components2.default)(TypeformPopup)``;

// src/beacon-link/BeaconLink.js
var BeaconLink = ({
  children,
  light,
  mailto,
  message,
  subject,
  user,
  ...unhandledProps
}) => {
  const { email, fullname: name } = user != null ? user : {};
  const text = ["Hi,", message, "Thanks!"].join("\n\n");
  const formValues = { mailto, message, subject, name, email, text };
  return /* @__PURE__ */ import_react3.default.createElement(TypeformPopup_default, {
    "data-testid": "typeform-beacon",
    childProps: { light },
    hiddenFormValues: formValues,
    ...unhandledProps
  }, children);
};
BeaconLink.propTypes = {
  children: import_prop_types.default.node,
  light: import_prop_types.default.bool,
  mailto: import_prop_types.default.string,
  message: import_prop_types.default.string,
  subject: import_prop_types.default.string,
  user: import_prop_types.default.shape({
    email: import_prop_types.default.string,
    fullname: import_prop_types.default.string
  })
};
var BeaconLink_default = BeaconLink;

// src/MagicIcon.js
var import_react4 = __toESM(require("react"));
var import_prop_types2 = __toESM(require("prop-types"));
var import_styled_components3 = __toESM(require("styled-components"));
function MagicIcon({ className }) {
  return /* @__PURE__ */ import_react4.default.createElement("svg", {
    className,
    height: "1.6em",
    role: "img",
    viewBox: "0 0 24 24",
    width: "1.6em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ import_react4.default.createElement("path", {
    d: "M4.17683 23.7126C4.26233 23.8116 4.3705 23.8893 4.49249 23.9392C4.61447 23.9892 4.74678 24.01 4.87853 23.9999C5.00937 24.0024 5.13932 23.9782 5.26011 23.9288C5.38091 23.8793 5.48993 23.8057 5.58023 23.7126L20.8757 8.68692C21.0615 8.50366 21.1666 8.25591 21.1681 7.99719C21.1521 7.73913 21.0492 7.49364 20.8757 7.2993L16.9913 3.48129C16.7941 3.31643 16.548 3.21855 16.2896 3.20215C16.0279 3.2032 15.7767 3.30313 15.5879 3.48129L0.292393 18.5152C0.198484 18.6045 0.124112 18.7118 0.073839 18.8304C0.0235658 18.949 -0.00155625 19.0764 1.05018e-05 19.2049C-0.0102315 19.3344 0.0109286 19.4644 0.0617552 19.5843C0.112582 19.7042 0.19163 19.8105 0.292393 19.8946L4.17683 23.7126ZM12.5305 9.65578L16.2478 6.00199L18.2694 7.99719L14.552 11.651L12.5305 9.65578Z",
    fill: "currentColor"
  }), /* @__PURE__ */ import_react4.default.createElement("path", {
    d: "M22.1455 14.3688C22.1322 14.3281 22.1068 14.2923 22.0726 14.2659C22.0383 14.2396 21.9968 14.2239 21.9534 14.2211L20.7839 14.1143L20.3161 13.0469C20.2996 13.008 20.2717 12.9748 20.2361 12.9514C20.2004 12.928 20.1585 12.9155 20.1156 12.9155C20.0727 12.9155 20.0308 12.928 19.9951 12.9514C19.9594 12.9748 19.9316 13.008 19.9151 13.0469L19.4556 14.1143L18.2778 14.2211C18.2347 14.225 18.1937 14.241 18.1596 14.2672C18.1256 14.2934 18.0999 14.3287 18.0857 14.3688C18.0728 14.4081 18.0724 14.4503 18.0843 14.4898C18.0962 14.5294 18.12 14.5645 18.1525 14.5906L19.038 15.3624L18.779 16.4954C18.7712 16.5364 18.7748 16.5786 18.7896 16.6176C18.8043 16.6567 18.8295 16.6911 18.8625 16.7171C18.8998 16.7416 18.9431 16.7558 18.9878 16.7582C19.0265 16.7655 19.0662 16.7655 19.1048 16.7582L20.1156 16.1588L21.1347 16.7582C21.1697 16.7801 21.2102 16.7918 21.2517 16.7918C21.2931 16.7918 21.3337 16.7801 21.3686 16.7582C21.4017 16.7321 21.4269 16.6977 21.4416 16.6587C21.4563 16.6196 21.46 16.5774 21.4522 16.5365L21.1932 15.4034L22.0787 14.6316C22.1204 14.6032 22.1501 14.5609 22.1624 14.5126C22.1747 14.4642 22.1687 14.4132 22.1455 14.3688Z",
    fill: "var(--orange-line)"
  }), /* @__PURE__ */ import_react4.default.createElement("path", {
    d: "M11.6366 2.70127C11.6262 2.66497 11.6045 2.63282 11.5745 2.60926C11.5446 2.5857 11.5078 2.57194 11.4695 2.56992L10.4086 2.4714L9.99094 1.51075C9.97522 1.47529 9.94962 1.44489 9.91711 1.4231C9.88459 1.40131 9.84648 1.389 9.80715 1.38757C9.76874 1.3885 9.73148 1.40075 9.70021 1.4227C9.66894 1.44466 9.64509 1.47534 9.63173 1.51075L9.21405 2.4714L8.15312 2.56992C8.11443 2.57064 8.07709 2.5839 8.04687 2.60766C8.01665 2.63142 7.99527 2.66433 7.98607 2.70127C7.97336 2.73527 7.97134 2.77227 7.98028 2.80741C7.98922 2.84255 8.00869 2.87425 8.03619 2.89837L8.87155 3.58805L8.63765 4.61439C8.62766 4.65084 8.62954 4.68945 8.64303 4.72479C8.65651 4.76014 8.68092 4.79043 8.71283 4.81144C8.74641 4.83694 8.78735 4.85136 8.82977 4.85253C8.86279 4.85965 8.89701 4.85965 8.93003 4.85253L9.84058 4.31881L10.7511 4.85253C10.7836 4.87379 10.8218 4.88482 10.8608 4.8842C10.8998 4.88359 10.9377 4.87135 10.9694 4.84907C11.0011 4.8268 11.0252 4.79557 11.0384 4.75952C11.0517 4.72347 11.0534 4.68432 11.0435 4.64726L10.8096 3.62092L11.645 2.9312C11.671 2.89789 11.6843 2.85674 11.6828 2.81478C11.6813 2.77283 11.665 2.73267 11.6366 2.70127Z",
    fill: "var(--cutecumber)"
  }), /* @__PURE__ */ import_react4.default.createElement("path", {
    d: "M7.51825 6.21557C7.50423 6.16177 7.47323 6.11371 7.42971 6.0783C7.38619 6.0429 7.33237 6.02199 7.27599 6.01852L5.72222 5.87895L5.10403 4.46667C5.08224 4.41488 5.0451 4.37074 4.99742 4.33998C4.94974 4.30923 4.89373 4.29327 4.83671 4.29423C4.78111 4.2949 4.72696 4.31164 4.68092 4.34229C4.63489 4.37294 4.59901 4.41617 4.57775 4.46667L3.95959 5.87895L2.40583 6.01852C2.34871 6.0227 2.2942 6.04374 2.24948 6.0789C2.20475 6.11407 2.17189 6.16171 2.1552 6.21557C2.1393 6.26756 2.13871 6.32292 2.15349 6.37523C2.16828 6.42754 2.19783 6.47466 2.23874 6.51114L3.41661 7.5211L3.07411 9.02363C3.06105 9.07794 3.06438 9.13481 3.08367 9.1873C3.10295 9.23979 3.13736 9.28567 3.18271 9.31925C3.23222 9.35154 3.29035 9.36868 3.34977 9.36851C3.40299 9.37035 3.45552 9.35598 3.50015 9.32742L4.83671 8.50635L6.18166 9.32742C6.22962 9.35682 6.2854 9.37151 6.34189 9.36957C6.39837 9.36762 6.453 9.34917 6.49875 9.31655C6.54449 9.28392 6.5793 9.23862 6.59871 9.18645C6.61812 9.13427 6.62125 9.07756 6.6077 9.02363L6.2652 7.5211L7.43471 6.51114C7.47944 6.4775 7.51179 6.43048 7.52687 6.37714C7.54194 6.32379 7.53892 6.26706 7.51825 6.21557Z",
    fill: "var(--pink-power-ranger)"
  }), /* @__PURE__ */ import_react4.default.createElement("path", {
    d: "M6.27357 1.04278C6.26325 1.01474 6.24536 0.989972 6.22181 0.971167C6.19827 0.952362 6.16997 0.940223 6.13993 0.936037L5.30457 0.862118L4.9704 0.0985251C4.95904 0.0703055 4.93956 0.0459657 4.91434 0.0284652C4.88912 0.0109647 4.85926 0.00106741 4.8284 1.97405e-07C4.79727 -4.98382e-05 4.76688 0.00941308 4.74145 0.027062C4.71601 0.0447109 4.69676 0.0696712 4.68638 0.0985251L4.35224 0.862118L3.51688 0.936037C3.48616 0.938232 3.45686 0.949621 3.43295 0.968711C3.40905 0.987802 3.39169 1.01368 3.38321 1.04278C3.37522 1.07137 3.37488 1.10151 3.38219 1.13028C3.38951 1.15905 3.40426 1.18547 3.425 1.20701L4.06822 1.75711L3.87608 2.57819C3.86878 2.60695 3.87047 2.63721 3.88089 2.66503C3.89132 2.69285 3.91001 2.71695 3.93456 2.73419C3.96434 2.7442 3.99665 2.7442 4.02644 2.73419C4.05365 2.74242 4.08276 2.74242 4.10998 2.73419L4.83674 2.30722L5.56353 2.73419C5.58909 2.75224 5.61975 2.76195 5.65122 2.76195C5.6827 2.76195 5.71338 2.75224 5.73895 2.73419C5.76267 2.71625 5.78073 2.69209 5.79108 2.66448C5.80143 2.63688 5.80364 2.60696 5.79743 2.57819L5.60529 1.75711L6.24851 1.20701C6.26641 1.18392 6.27811 1.15673 6.28249 1.12803C6.28687 1.09932 6.28379 1.07001 6.27357 1.04278Z",
    fill: "var(--bludacris)"
  }));
}
MagicIcon.propTypes = {
  className: import_prop_types2.default.string
};
var MagicIcon_default = (0, import_styled_components3.default)(MagicIcon)``;

// src/styled.js
var SMALL_ICONS = /* @__PURE__ */ new Set(["comment-alt"]);
var Wrapper = import_styled_components4.default.div`
  background-color: var(--white);
  border-right: 1px solid var(--nav-border);
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: var(--navigation-position, fixed);
  top: 0;
  width: var(--nav-width);
  z-index: 9999;
`;
var Header = import_styled_components4.default.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px 0;

  ${import_legacy_components.Logo} {
    width: 20px;
  }
`;
var Scrollable = import_styled_components4.default.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
`;
var Links = import_styled_components4.default.nav`
  flex-grow: 1;
`;
var Group = import_styled_components4.default.ul`
  padding: 12px 0;
  list-style-type: none;
`;
var Divider = (0, import_styled_components4.default)(import_react_separator.Separator)`
  background: var(--ui-horizontal-separator);
  height: 1px;
`;
var InstallWrapper = (0, import_styled_components4.default)(import_legacy_components.Button)`
  align-items: center;
  background: var(--nav-install-bg);
  color: var(--nav-install-color);
  display: flex;
  font-size: var(--regular);
  font-weight: var(--bold);
  justify-content: center;
  padding: 8px;

  ${MagicIcon_default} {
    color: var(--nav-install-icon-color);
    margin-right: 8px;
    transition: ${(0, import_legacy_components.easing)("color")};
  }

  :hover {
    background: var(--nav-install-hover);

    ${MagicIcon_default} {
      color: var(--nav-install-icon-hover);
    }
  }
`;
var TrialWrapper = import_styled_components4.default.div`
  text-align: center;

  ${import_legacy_components.Skeleton} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${import_legacy_components.Progress} {
    height: 12px;
    margin-bottom: 10px;
  }

  ${import_legacy_components.Button} {
    --link-color: var(--white);
    --link-text-decoration: none;
    --link-visited-color: var(--white);

    margin: 0 12px;
  }
`;
var TrialByDaysWrapper = import_styled_components4.default.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${import_legacy_components.Skeleton} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${import_legacy_components.Button} {
    --link-color: var(--white);
    --link-text-decoration: none;
    --link-visited-color: var(--white);
  }
`;
var Counter = import_styled_components4.default.div`
  font-weight: var(--bold);
  color: var(--heading-primary);
  font-size: var(--regular);
`;
var TrialMessage = import_styled_components4.default.div`
  color: var(--heading-primary);
  font-size: var(--regular);
  margin-bottom: 10px;
`;
var CallToActions = import_styled_components4.default.div`
  display: flex;
  flex-direction: column;

  > ${InstallWrapper}, > ${TrialWrapper} {
    margin: 0 24px 24px;
  }
`;
var NavItemWrapper = import_styled_components4.default.li`
  height: 40px;
`;
var IconWrapper = import_styled_components4.default.div`
  display: flex;
  justify-content: center;
  margin-right: 12px;
  width: 20px;
`;
var ItemIcon = (0, import_styled_components4.default)(import_legacy_components.Icon)`
  color: var(--text-secondary);
  font-size: var(--regular);

  ${({ icon }) => SMALL_ICONS.has(icon) && `
      font-size: var(--small) ;
    `}

  ${({ icon }) => icon === "thumbtack" && `
      transform: rotate(45deg);
    `}
`;
var ItemLink = import_styled_components4.default.a`
  align-items: center;
  color: var(--heading-primary);
  display: flex;
  font-size: var(--regular);
  font-weight: var(--normal);
  height: 100%;
  padding-left: 36px;
  text-decoration: none;

  ${ItemIcon}, ${import_sonar2.Icon} {
    color: var(--text-secondary);

    svg path {
      fill: var(--text-secondary);
    }
  }

  &.active {
    background-color: var(--nav-item-active);
    font-weight: var(--bold);

    ${ItemIcon} {
      color: var(--primary);
    }

    svg path {
      fill: var(--primary);
    }
  }

  &:hover:not(.active),
  &:focus-visible {
    color: var(--primary);

    ${ItemIcon} {
      color: var(--primary);
    }

    svg path {
      fill: var(--primary);
    }
  }
`;
var NavBeaconLink = (0, import_styled_components4.default)(BeaconLink_default)`
  align-items: center;
  color: var(--disabled);
  display: flex;
  height: 100%;
  padding-left: 36px;
  &:hover,
  ${ItemIcon} {
    color: var(--disabled);
  }

  &:hover {
    svg path {
      fill: var(--disabled);
    }
  }
`;
var AccountMenuContent = (0, import_styled_components4.default)(import_legacy_components.MenuContent)`
  width: 235px;
`;
var GearIcon = (0, import_styled_components4.default)(import_legacy_components.Icon)`
  color: var(--dark-resting);
  font-size: var(--medium-large);
`;
var CaretIcon = (0, import_styled_components4.default)(import_legacy_components.Icon)`
  color: var(--dark-resting);
  font-size: var(--xx-small);
`;
var AccountMenuTrigger = import_styled_components4.default.div`
  padding: 16px 24px 16px 36px;

  &:hover {
    ${GearIcon} {
      color: var(--blurple);
    }
  }

  ${CaretIcon} {
    margin-right: 0;
  }

  ${({ open }) => open && `
      ${GearIcon} {
        color: var(--blurple);
      }
    `}
`;
var SpoofForm = import_styled_components4.default.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px 0;
  position: relative;
`;
var SpoofFormField = import_styled_components4.default.div`
  display: flex;

  ${import_legacy_components.Button} {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: 76px;
  }

  ${import_legacy_components.Input} {
    border-bottom-right-radius: 0;
    border-color: var(--text-tertiary);
    border-top-right-radius: 0;
    width: 100%;
  }
`;
var ProgressBarWrapper = import_styled_components4.default.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;
var TooltipLabel = import_styled_components4.default.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: var(--font-size-small);
`;

// src/AccountMenuButton.js
var AccountMenuButton = ({ company, name, open, ...unhandledProps }) => /* @__PURE__ */ import_react5.default.createElement(import_legacy_components2.MenuTrigger, {
  asChild: true
}, /* @__PURE__ */ import_react5.default.createElement(AccountMenuTrigger, {
  role: "button",
  open,
  ...unhandledProps
}, /* @__PURE__ */ import_react5.default.createElement(import_legacy_components2.ListRowContent, {
  description: name,
  prefix: /* @__PURE__ */ import_react5.default.createElement(GearIcon, {
    icon: "cog"
  }),
  suffix: /* @__PURE__ */ import_react5.default.createElement(CaretIcon, {
    icon: "angle-right"
  }),
  title: `${name} (${company})`
}, company)));
AccountMenuButton.propTypes = {
  company: import_prop_types3.default.string,
  name: import_prop_types3.default.string,
  open: import_prop_types3.default.bool
};
var AccountMenuButton_default = AccountMenuButton;

// src/AccountMenu.js
var AccountMenu = ({
  account,
  accounts,
  onLogout,
  user,
  Link: Link2,
  children
}) => {
  const [openState, toggle] = useToggle(false);
  const { name: companyName } = account != null ? account : {};
  const { email, fullname: name } = user != null ? user : {};
  const label = companyName || email;
  const count = Object.keys(accounts != null ? accounts : {}).length;
  return /* @__PURE__ */ import_react6.default.createElement(import_react6.default.Fragment, null, /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuPortalOverride, null), /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.Menu, {
    onOpenChange: toggle,
    open: openState
  }, /* @__PURE__ */ import_react6.default.createElement(AccountMenuButton_default, {
    company: label,
    name,
    open: openState
  }), /* @__PURE__ */ import_react6.default.createElement(AccountMenuContent, {
    align: "end",
    side: "right",
    sideOffset: 12
  }, /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuSection, null, count > 1 ? /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.ListRow, {
    forwardedAs: Link2,
    description: "Switch accounts",
    to: "/accounts"
  }, label) : /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuHeading, {
    title: label
  }, label)), /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuSeparator, null), /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuSection, null, children), /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuSeparator, null), /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.MenuSection, null, /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.ListRow, {
    onClick: onLogout,
    suffix: /* @__PURE__ */ import_react6.default.createElement(import_legacy_components3.Icon, {
      icon: "sign-out-alt"
    })
  }, "Sign out")))));
};
AccountMenu.propTypes = {
  account: import_prop_types4.default.shape({ name: import_prop_types4.default.string }),
  accounts: import_prop_types4.default.objectOf(import_prop_types4.default.shape({ name: import_prop_types4.default.string })),
  onLogout: import_prop_types4.default.func,
  user: import_prop_types4.default.shape({
    email: import_prop_types4.default.string,
    fullname: import_prop_types4.default.string
  }),
  Link: import_prop_types4.default.oneOfType([import_prop_types4.default.element, import_prop_types4.default.object]),
  children: import_prop_types4.default.node.isRequired
};
var AccountMenu_default = AccountMenu;

// src/AccountMenuItem.js
var import_react7 = __toESM(require("react"));
var import_prop_types5 = __toESM(require("prop-types"));
var import_legacy_components4 = require("@studio/legacy-components");
var AccountMenuItem = ({
  Link: Link2 = import_legacy_components4.Link,
  baseUrl = "",
  path = "",
  label = "",
  external = false,
  ...props
}) => {
  const linkProps = (0, import_react7.useMemo)(() => {
    if (external) {
      return {
        forwardedAs: "a",
        href: `${baseUrl}${path}`
      };
    }
    return {
      forwardedAs: Link2,
      to: path
    };
  }, [Link2, baseUrl, external, path]);
  const unhandledProps = {
    ...props,
    ...linkProps
  };
  return /* @__PURE__ */ import_react7.default.createElement(import_legacy_components4.ListRow, {
    ...unhandledProps
  }, label);
};
AccountMenuItem.propTypes = {
  external: import_prop_types5.default.bool,
  Link: import_prop_types5.default.oneOfType([import_prop_types5.default.element, import_prop_types5.default.object]),
  baseUrl: import_prop_types5.default.string,
  path: import_prop_types5.default.string,
  label: import_prop_types5.default.string
};
var AccountMenuItem_default = AccountMenuItem;

// src/HelpMenu.js
var import_react8 = __toESM(require("react"));
var import_server = require("react-dom/server");
var import_prop_types6 = __toESM(require("prop-types"));
var import_styled_components5 = __toESM(require("styled-components"));
var import_legacy_components5 = require("@studio/legacy-components");
var LAUNCHPAD_ID = "appcues-launchpad";
var LAUNCHPAD_CONTAINER_CLASS = "appcues";
var LAUNCHPAD_ACTIVE_CLASS = "appcues-widget-container appcues-active";
var LAUNCHPAD_OVERLAY = ".appcues-widget-backdrop";
var ASK_SUPPORT_ID = "ask-support-opener";
var WHATS_NEW_ID = "whats-new";
var LaunchpadStyle = import_styled_components5.createGlobalStyle`
  /* Launchpad styles */
  .appcues {
    .appcues-widget-dropdown.appcues-widget-fixed.appcues-widget-top-right {
      border-radius: 6px;
      box-shadow: var(--dropdown-menu-shadow);
      margin: 0;
      padding: 0;
      position: fixed;
      transform: translateX(-10px) translateY(calc(20px - 100% + 40px + 20px + 10px));

      &:after, &:before {
        border: solid transparent;
        bottom: 40px;
        content: "";
        height: 0;
        left: -10px;
        position: absolute;
        right: unset;
        top: unset;
        width: 0;
      }

      &:after {
        border-right-color: var(--white);
        border-width: 10px;
      }
    }

    .appcues-widget-icon {
      height: 40px;
      left: 0;
      margin-left: 0;
      opacity: 1; /* override widget fade-in */
      position: absolute;
      top: 0;
      width: 100%;

      &.appcues-icon-visible::after,
      &.appcues-icon-visible::before {
        display: none;
      }
    }

    .appcues-widget-dropdown .appcues-widget-content {
      overflow-y: auto;
      padding-top: 4px;
    }

    .appcues-widget-container {
      li.appcues-nothing-new {
        display: none;
      }

      a[data-itemid] time {
        display: none;
      }
    }

    .appcues-widget-list {
      border-bottom: none;

      li {
        &.appcues-read,
        &.appcues-unread {
          color: var(--heading-primary);
          font-weight: normal;
          position: relative;
        }

        &:last-of-type {
          border-bottom: 1px solid var(--myst);
        }

        &:before {
          background-color: var(--primary);
          border-radius: 50%;
          content: ' ';
          height: 8px;
          left: 20px;
          position: absolute;
          top: calc(50% - 4px);
          width: 8px;
        }

        a {
          align-items: center;
          display: flex;
          min-height: 40px;
          padding: 4px 20px 4px 40px;

          &:hover {
            background-color: var(--nav-item-active);
          }
        }
      }
    }
  }


  /* Customizing position of Canny Widget
  * maintains its top position
  */
  #canny-changelog-iframe {
    position: fixed !important;
    top: 115px !important;
  }
`;
var HelpIcon = (0, import_styled_components5.default)(ItemIcon)`
  ${({ open }) => open && `
      color: var(--primary);
    `}
`;
var Text = import_styled_components5.default.span`
  color: var(--heading-primary);
  font-weight: var(--normal);
  font-size: var(--regular);

  ${({ open }) => open && `
      font-weight: var(--bold);
    `}
`;
var FooterItems = import_styled_components5.default.ul`
  list-style-type: none;
  padding: 4px 0;
`;
var FooterItem = import_styled_components5.default.li`
  height: 40px;
`;
var baseLinkStyles = import_styled_components5.css`
  --link-text-decoration: none;
  --link-visited-color: var(--heading-primary);

  align-items: center;
  color: var(--heading-primary);
  display: flex;
  font-weight: var(--normal);
  padding-left: 20px;

  &:hover {
    background-color: var(--nav-item-active);
  }
`;
var FooterLink = (0, import_styled_components5.default)(import_legacy_components5.ExternalLink).attrs({
  "data-close-launchpad": "1"
})`
  ${baseLinkStyles}

  height: 100%;
  text-decoration: none;

  &:hover {
    color: var(--heading-primary);
  }
`;
var FooterButton = import_styled_components5.default.button`
  border: none;
  outline: none;
  background-color: var(--white);
  align-items: center;
  color: var(--heading-primary);
  display: flex;
  font-weight: var(--normal);
  padding-left: 20px;

  height: 100%;
  width: 100%;

  &.canny-open,
  &:hover {
    background-color: var(--nav-item-active);
    color: var(--heading-primary);
  }
`;
var AskSupport = import_styled_components5.default.button`
  ${baseLinkStyles}

  background: transparent;
  border: none;
  font-size: inherit;
  font-weight: var(--bold);
  height: 40px;
  width: 100%;
`;
var Wrapper2 = import_styled_components5.default.li`
  align-items: center;
  display: flex !important; /* To override the launchpad style */
  height: 40px;
  padding-left: 36px;
  width: 100%;

  &:hover {
    color: var(--primary);

    ${HelpIcon} {
      color: var(--primary);
    }
  }
`;
var Footer = ({ hasCannyEnabled }) => {
  return /* @__PURE__ */ import_react8.default.createElement(FooterItems, null, /* @__PURE__ */ import_react8.default.createElement(FooterItem, null, /* @__PURE__ */ import_react8.default.createElement(AskSupport, {
    id: ASK_SUPPORT_ID,
    "data-close-launchpad": "1"
  }, "Ask support")), /* @__PURE__ */ import_react8.default.createElement(FooterItem, null, /* @__PURE__ */ import_react8.default.createElement(FooterButton, {
    id: WHATS_NEW_ID,
    "data-canny-changelog": true
  }, "What's new")), /* @__PURE__ */ import_react8.default.createElement(FooterItem, null, /* @__PURE__ */ import_react8.default.createElement(FooterLink, {
    href: "https://docs.appcues.com/",
    icon: false
  }, "Help docs")), hasCannyEnabled && /* @__PURE__ */ import_react8.default.createElement(FooterItem, null, /* @__PURE__ */ import_react8.default.createElement(FooterLink, {
    href: "https://feedback.appcues.com/product-feedback?sort=top",
    icon: false
  }, "Suggest a feature")));
};
Footer.propTypes = {
  hasCannyEnabled: import_prop_types6.default.bool
};
var closeLaunchpad = () => {
  document.querySelector(LAUNCHPAD_OVERLAY).click();
};
var HelpMenu = ({
  account,
  hasCannyEnabled,
  user,
  location,
  cannyAppId
}) => {
  const [open, setOpen] = (0, import_react8.useState)(false);
  const chatEnabled = account == null ? void 0 : account.isTrial;
  const handleLaunchpadOpened = (mutations) => {
    try {
      mutations.forEach((mutation) => {
        var _a, _b;
        if (mutation.target.className === LAUNCHPAD_CONTAINER_CLASS) {
          if (((_a = mutation.addedNodes[0]) == null ? void 0 : _a.className) === LAUNCHPAD_ACTIVE_CLASS) {
            setOpen(true);
            window.Canny("initChangelog", {
              appID: cannyAppId,
              position: "right",
              align: "bottom"
            });
          } else if (((_b = mutation.removedNodes[0]) == null ? void 0 : _b.className) === LAUNCHPAD_ACTIVE_CLASS) {
            setOpen(false);
            window.Canny("closeChangelog");
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  (0, import_react8.useEffect)(() => {
    const loadLaunchpad = () => {
      var _a;
      (_a = window.Appcues) == null ? void 0 : _a.loadLaunchpad(`#${LAUNCHPAD_ID}`, {
        position: "top-right",
        footer: (0, import_server.renderToStaticMarkup)(
          /* @__PURE__ */ import_react8.default.createElement(Footer, {
            hasCannyEnabled
          })
        )
      });
    };
    loadLaunchpad();
  }, [hasCannyEnabled, location]);
  (0, import_react8.useEffect)(() => {
    const handleLaunchpadClick = (event) => {
      if (event.target.dataset.closeLaunchpad === "1") {
        closeLaunchpad();
      }
      if (event.target.id === WHATS_NEW_ID) {
        event.target.classList.toggle("canny-open");
      }
      if (event.target.id === ASK_SUPPORT_ID) {
        try {
          window.Beacon("prefill", {
            name: user == null ? void 0 : user.fullname,
            email: user == null ? void 0 : user.email,
            subject: "",
            text: ""
          });
          window.Beacon("navigate", "/ask/");
          window.Beacon("open");
          window.Beacon("config", {
            messaging: { chatEnabled }
          });
        } catch (error) {
          console.error(error);
        }
      }
    };
    if (window.Appcues) {
      const observer = new MutationObserver(handleLaunchpadOpened);
      document.addEventListener("click", handleLaunchpadClick);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      return () => {
        document.removeEventListener("click", handleLaunchpadClick);
        observer.disconnect();
      };
    }
  }, [user, chatEnabled]);
  (0, import_react8.useEffect)(() => {
    if (hasCannyEnabled && account && user) {
      const { id: accountId, isTrial, tier, stripePlanId } = account;
      const { email, fullname, id: userId, avatarURL, job, crxVersion } = user;
      window.Canny("identify", {
        appID: cannyAppId,
        user: {
          email,
          name: fullname || "anonymous",
          id: userId,
          avatarURL,
          customFields: {
            job,
            crxVersion
          },
          companies: [
            {
              customFields: {
                isTrial,
                tier,
                stripePlanId
              },
              id: accountId,
              name: accountId
            }
          ]
        }
      });
    }
  }, [account, hasCannyEnabled, user]);
  return /* @__PURE__ */ import_react8.default.createElement(Wrapper2, {
    id: LAUNCHPAD_ID
  }, /* @__PURE__ */ import_react8.default.createElement(LaunchpadStyle, null), /* @__PURE__ */ import_react8.default.createElement(IconWrapper, null, /* @__PURE__ */ import_react8.default.createElement(HelpIcon, {
    icon: "comment",
    title: "Help",
    open
  })), /* @__PURE__ */ import_react8.default.createElement(Text, {
    open
  }, "Help"));
};
HelpMenu.propTypes = {
  account: import_prop_types6.default.shape({
    id: import_prop_types6.default.string,
    isTrial: import_prop_types6.default.bool,
    tier: import_prop_types6.default.string,
    stripePlanId: import_prop_types6.default.string
  }),
  hasCannyEnabled: import_prop_types6.default.bool,
  user: import_prop_types6.default.shape({
    email: import_prop_types6.default.string,
    fullname: import_prop_types6.default.string,
    id: import_prop_types6.default.string,
    avatarURL: import_prop_types6.default.string,
    job: import_prop_types6.default.string,
    crxVersion: import_prop_types6.default.string
  }),
  location: import_prop_types6.default.string,
  cannyAppId: import_prop_types6.default.string
};
var HelpMenu_default = HelpMenu;

// src/help-menu/PopoverHelpMenu.js
var import_prop_types10 = __toESM(require("prop-types"));
var import_react12 = __toESM(require("react"));
var import_legacy_components12 = require("@studio/legacy-components");

// src/help-menu/HelpMenuButton.js
var import_prop_types7 = __toESM(require("prop-types"));
var import_react9 = __toESM(require("react"));
var import_legacy_components7 = require("@studio/legacy-components");

// src/help-menu/HelpIcon.js
var import_styled_components6 = __toESM(require("styled-components"));
var import_legacy_components6 = require("@studio/legacy-components");
var HelpIcon2 = (0, import_styled_components6.default)(import_legacy_components6.Icon)`
  color: var(--dark-resting);
  font-size: var(--medium-large);
  padding-right: 4px;
`;

// src/help-menu/HelpMenuTrigger.js
var import_styled_components7 = __toESM(require("styled-components"));
var HelpMenuTrigger = import_styled_components7.default.div`
  padding: 16px 24px 16px 36px;

  &:hover {
    ${HelpIcon2} {
      color: var(--blurple);
    }
  }

  ${({ open }) => open && `
      ${HelpIcon2} {
        color: var(--blurple);
      }
    `}
`;

// src/help-menu/HelpMenuButton.js
var HelpMenuButton = ({ open, ...unhandledProps }) => /* @__PURE__ */ import_react9.default.createElement(import_legacy_components7.MenuTrigger, {
  asChild: true
}, /* @__PURE__ */ import_react9.default.createElement(HelpMenuTrigger, {
  role: "button",
  open,
  ...unhandledProps
}, /* @__PURE__ */ import_react9.default.createElement(import_legacy_components7.ListRowContent, {
  prefix: /* @__PURE__ */ import_react9.default.createElement(HelpIcon2, {
    icon: "comment"
  }),
  caret: true
}, "Help")));
HelpMenuButton.propTypes = {
  open: import_prop_types7.default.bool
};

// src/help-menu/LaunchpadFlowList.js
var import_react11 = __toESM(require("react"));
var import_legacy_components11 = require("@studio/legacy-components");

// src/help-menu/LaunchpadFlowListItem.js
var import_prop_types9 = __toESM(require("prop-types"));
var import_react10 = __toESM(require("react"));
var import_legacy_components10 = require("@studio/legacy-components");

// ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCircleSmall = {
  prefix: "fas",
  iconName: "circle-small",
  icon: [320, 512, [], "e122", "M320 256c0 88.4-71.6 160-160 160S0 344.4 0 256S71.6 96 160 96s160 71.6 160 160z"]
};

// src/help-menu/UnreadIndicator.js
var import_styled_components8 = __toESM(require("styled-components"));
var import_legacy_components8 = require("@studio/legacy-components");
var UnreadIndicator = (0, import_styled_components8.default)(import_legacy_components8.Icon)`
  color: var(--blurple) !important;

  &:hover {
    background-color: var(--nav-item-active);
    color: var(--blurple) !important;
  }
`;

// src/help-menu/HelpLink.js
var import_styled_components9 = __toESM(require("styled-components"));
var import_legacy_components9 = require("@studio/legacy-components");
var HelpLink = (0, import_styled_components9.default)(import_legacy_components9.ExternalLink)`
  --link-text-decoration: none;
  --link-visited-color: var(--heading-primary);

  color: var(--heading-primary);
  display: flex;
  font-weight: var(--normal);

  &:hover {
    background-color: var(--nav-item-active);
    color: var(--heading-primary);
  }
  height: 100%;
  text-decoration: none;
`;

// src/help-menu/proptypes.js
var import_prop_types8 = __toESM(require("prop-types"));
var LaunchpadHistoryPropType = import_prop_types8.default.shape({
  flows: import_prop_types8.default.objectOf(import_prop_types8.default.bool)
});
var FlowPropType = import_prop_types8.default.shape({
  id: import_prop_types8.default.string,
  name: import_prop_types8.default.string
});
var LaunchpadContentPropType = import_prop_types8.default.shape({
  content: FlowPropType
});
var LaunchpadPropType = import_prop_types8.default.shape({
  launchpad: LaunchpadContentPropType,
  history: LaunchpadHistoryPropType
});

// src/help-menu/LaunchpadFlowListItem.js
var LaunchpadFlowListItem = ({ flow, isUnread }) => {
  return /* @__PURE__ */ import_react10.default.createElement(import_legacy_components10.ListRow, {
    prefix: isUnread && /* @__PURE__ */ import_react10.default.createElement(UnreadIndicator, {
      icon: faCircleSmall
    })
  }, /* @__PURE__ */ import_react10.default.createElement(HelpLink, {
    icon: false,
    onClick: () => window.Appcues.show(flow.id)
  }, flow.name));
};
LaunchpadFlowListItem.propTypes = {
  flow: FlowPropType,
  isUnread: import_prop_types9.default.bool
};

// src/help-menu/LaunchpadFlowList.js
var LaunchpadFlowList = ({ launchpadData }) => {
  if (!launchpadData) {
    return null;
  }
  const { launchpad, history } = launchpadData;
  const flows = launchpad && launchpad.contents || [];
  const seenFlows = history && history.flows || [];
  if (flows.length === 0)
    return null;
  return /* @__PURE__ */ import_react11.default.createElement(import_react11.default.Fragment, null, /* @__PURE__ */ import_react11.default.createElement(import_legacy_components11.MenuSection, null, flows.map((flow) => /* @__PURE__ */ import_react11.default.createElement(LaunchpadFlowListItem, {
    key: flow.id,
    flow,
    isUnread: seenFlows[flow.id] !== true
  }))), /* @__PURE__ */ import_react11.default.createElement(import_legacy_components11.MenuSeparator, null));
};
LaunchpadFlowList.propTypes = {
  launchpadData: LaunchpadPropType
};

// src/help-menu/MenuWrapper.js
var import_styled_components10 = __toESM(require("styled-components"));
var MenuWrapper = import_styled_components10.default.div`
  font-size: var(--font-size-regular);
`;

// src/help-menu/TypeformLaunchpadOverrideStyle.js
var import_styled_components11 = require("styled-components");
var TypeformLaunchpadOverrideStyle = import_styled_components11.createGlobalStyle`
  /* Typeform: Make it appear above the popover */
  .tf-v1-popup {
    z-index: 2147483647 !important;
  }
  `;

// src/help-menu/CannyLaunchpadOverrideStyle.js
var import_styled_components12 = require("styled-components");
var CannyLaunchpadOverrideStyle = import_styled_components12.createGlobalStyle`
  /* Tweak the color and position of the Canny unread dot */
.Canny_BadgeContainer .Canny_Badge {
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 10px;
  background-color: var(--blurple) !important;
  padding: 5px;
  border: 1px solid white;

};

#canny-changelog-iframe {
  pointer-events: all !important;
};
`;

// src/help-menu/styled.js
var import_styled_components13 = __toESM(require("styled-components"));
var AskSupport2 = (0, import_styled_components13.default)(TypeformPopup_default)`
  --font-size-regular: var(--font-size-regular);
  color: var(--heading-primary);
  font-weight: var(--bold);
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
  > * {
    color: var(--heading-primary);
  }
`;

// src/help-menu/PopoverHelpMenu.js
var PopoverHelpMenu = ({ user, account, cannyAppId, launchpadData }) => {
  const [openState, toggle] = useToggle(false);
  (0, import_react12.useEffect)(() => {
    if (window.Canny && account && user) {
      const { id: accountId, isTrial, tier, stripePlanId } = account;
      const { fullname, email, id: userId, avatarURL, job, crxVersion } = user;
      window.Canny("identify", {
        appID: cannyAppId,
        user: {
          email,
          name: fullname || "anonymous",
          id: userId,
          avatarURL,
          customFields: {
            job,
            crxVersion
          },
          companies: [
            {
              customFields: {
                isTrial,
                tier,
                stripePlanId
              },
              id: accountId,
              name: accountId
            }
          ]
        }
      });
    }
  }, [account, cannyAppId, user]);
  (0, import_react12.useEffect)(() => {
    if (!openState && window.Canny) {
      window.Canny("closeChangelog");
    }
  }, [openState]);
  (0, import_react12.useEffect)(() => {
    const observer = new MutationObserver(() => {
      const changelogEl = document.querySelector("[data-canny-changelog]");
      if (changelogEl) {
        try {
          window.Canny("initChangelog", {
            appID: cannyAppId,
            position: "right",
            align: "bottom"
          });
        } catch (e) {
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, [cannyAppId]);
  const hiddenFormValues = {
    name: user == null ? void 0 : user.fullname,
    email: user == null ? void 0 : user.email,
    url: window.location.href
  };
  return /* @__PURE__ */ import_react12.default.createElement(MenuWrapper, null, /* @__PURE__ */ import_react12.default.createElement(CannyLaunchpadOverrideStyle, null), /* @__PURE__ */ import_react12.default.createElement(TypeformLaunchpadOverrideStyle, null), /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.Menu, {
    onOpenChange: toggle,
    open: openState
  }, /* @__PURE__ */ import_react12.default.createElement(HelpMenuButton, {
    open: openState
  }), /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.MenuContent, {
    align: "end",
    side: "right",
    sideOffset: 12
  }, /* @__PURE__ */ import_react12.default.createElement(LaunchpadFlowList, {
    launchpadData
  }), /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.MenuSection, null, /* @__PURE__ */ import_react12.default.createElement(AskSupport2, {
    forwardedAs: import_legacy_components12.ListRow,
    hiddenFormValues
  }, "Ask support"), window.Canny && /* @__PURE__ */ import_react12.default.createElement(HelpLink, {
    as: "div",
    "data-canny-changelog": true,
    icon: false
  }, /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.ListRow, {
    onClick: (e) => {
      e.preventDefault();
    }
  }, "What's new")), /* @__PURE__ */ import_react12.default.createElement(HelpLink, {
    href: "https://docs.appcues.com/",
    icon: false
  }, /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.ListRow, null, "Help docs")), /* @__PURE__ */ import_react12.default.createElement(HelpLink, {
    href: "https://docs.appcues.com/en_US/user-experiences-use-cases/",
    icon: false
  }, /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.ListRow, null, "Use Cases")), /* @__PURE__ */ import_react12.default.createElement(HelpLink, {
    href: "https://feedback.appcues.com/product-feedback?sort=top",
    icon: false
  }, /* @__PURE__ */ import_react12.default.createElement(import_legacy_components12.ListRow, null, "Suggest a feature"))))));
};
PopoverHelpMenu.propTypes = {
  account: import_prop_types10.default.shape({
    id: import_prop_types10.default.string,
    isTrial: import_prop_types10.default.bool,
    stripePlanId: import_prop_types10.default.string,
    tier: import_prop_types10.default.string
  }),
  cannyAppId: import_prop_types10.default.string,
  launchpadData: LaunchpadPropType,
  user: import_prop_types10.default.shape({
    avatarURL: import_prop_types10.default.string,
    crxVersion: import_prop_types10.default.string,
    email: import_prop_types10.default.string,
    fullname: import_prop_types10.default.string,
    id: import_prop_types10.default.string,
    job: import_prop_types10.default.string
  })
};
var PopoverHelpMenu_default = PopoverHelpMenu;

// src/InstallButton.js
var import_react13 = __toESM(require("react"));
var import_prop_types11 = __toESM(require("prop-types"));
var import_sonar3 = require("@appcues/sonar");
function InstallButton({ Link: Link2 }) {
  return /* @__PURE__ */ import_react13.default.createElement(InstallWrapper, {
    forwardedAs: Link2,
    to: "/settings/installation"
  }, /* @__PURE__ */ import_react13.default.createElement(import_sonar3.Tooltip, {
    size: "regular",
    content: "In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!"
  }, /* @__PURE__ */ import_react13.default.createElement(MagicIcon_default, null), "Install to publish"));
}
InstallButton.propTypes = {
  Link: import_prop_types11.default.oneOfType([import_prop_types11.default.string, import_prop_types11.default.object])
};
var InstallButton_default = InstallButton;

// src/SpoofBanner.js
var import_react14 = __toESM(require("react"));
var import_prop_types12 = __toESM(require("prop-types"));
var import_styled_components14 = __toESM(require("styled-components"));
var import_legacy_components13 = require("@studio/legacy-components");
var CancelSpoof = import_styled_components14.default.button`
  background: transparent;
  border: none;
  color: var(--white);
  font-size: var(--medium-large);
  font-weight: var(--bold);
  text-decoration: underline;

  &:hover {
    color: var(--nav-spoof-hover);
  }
`;
var Wrapper3 = (0, import_styled_components14.default)(import_legacy_components13.NegativeBanner)`
  font-size: var(--medium-large);
`;
var SpoofBanner = ({ accountId, onDespoof, spoofing }) => {
  if (!spoofing) {
    return null;
  }
  return /* @__PURE__ */ import_react14.default.createElement(Wrapper3, null, "Spoofing Account ", accountId, " ", /* @__PURE__ */ import_react14.default.createElement(CancelSpoof, {
    onClick: onDespoof
  }, "Stop spoofing"));
};
SpoofBanner.propTypes = {
  accountId: import_prop_types12.default.string,
  onDespoof: import_prop_types12.default.func,
  spoofing: import_prop_types12.default.bool
};
var SpoofBanner_default = SpoofBanner;

// src/SpoofControl.js
var import_react15 = __toESM(require("react"));
var import_prop_types13 = __toESM(require("prop-types"));
var import_legacy_components14 = require("@studio/legacy-components");
var import_sonar4 = require("@appcues/sonar");
var SpoofControl = ({ onSpoof, spoofing, user }) => {
  const [value, setValue] = (0, import_react15.useState)("");
  const [hasError, setHasError] = (0, import_react15.useState)(false);
  const { isAdmin } = user != null ? user : {};
  if (!isAdmin || spoofing) {
    return null;
  }
  const handleChange = (event) => {
    const { value: text } = event.target;
    if (text === "" || /^[\d\b]+$/.test(text)) {
      setHasError(false);
      setValue(text);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    onSpoof(value).catch(() => setHasError(true));
  };
  return /* @__PURE__ */ import_react15.default.createElement(SpoofForm, {
    onSubmit: handleSubmit
  }, /* @__PURE__ */ import_react15.default.createElement(SpoofFormField, null, /* @__PURE__ */ import_react15.default.createElement(import_legacy_components14.Input, {
    type: "text",
    placeholder: "Account ID",
    error: hasError,
    value,
    onChange: handleChange
  }), /* @__PURE__ */ import_react15.default.createElement(import_legacy_components14.Button, {
    kind: "primary",
    onClick: handleSubmit
  }, "Spoof")), hasError && /* @__PURE__ */ import_react15.default.createElement(import_sonar4.InlineMessage, {
    variant: "error"
  }, "Failed to spoof"));
};
SpoofControl.propTypes = {
  onSpoof: import_prop_types13.default.func,
  spoofing: import_prop_types13.default.bool,
  user: import_prop_types13.default.shape({ isAdmin: import_prop_types13.default.bool })
};
var SpoofControl_default = SpoofControl;

// src/TrialMeterByDays.js
var import_react16 = __toESM(require("react"));
var import_prop_types14 = __toESM(require("prop-types"));
var import_legacy_components15 = require("@studio/legacy-components");
var import_pluralize = __toESM(require_pluralize());

// src/lib.js
var import_moment = __toESM(require("moment"));
var diff = (start, end, unit) => {
  return (0, import_moment.default)(end).diff((0, import_moment.default)(start), unit, true);
};

// src/trial-status.js
var isTrialAccount = (account, trialStatus) => {
  if ((account == null ? void 0 : account.stripePlanId) || (trialStatus == null ? void 0 : trialStatus.isExpired))
    return false;
  return true;
};

// src/TrialMeterByDays.js
var TrialMeterByDays = ({
  account = {},
  trialStatus = {},
  className,
  Link: Link2
}) => {
  const { createdAt, expirationDate, isWebInstalled, lengthDays } = trialStatus;
  const isTrial = isTrialAccount(account, trialStatus);
  if (!isTrial || !createdAt || !expirationDate) {
    return null;
  }
  const trialDays = Math.ceil(
    diff(new Date(createdAt), new Date(expirationDate), "days")
  );
  const remainingDays = Math.ceil(
    diff(new Date(), new Date(expirationDate), "days")
  );
  const usedDays = trialDays - remainingDays;
  const progress = usedDays / trialDays;
  const percentage = Math.round(progress * 100, 2);
  const progressBarStatus = remainingDays > 7 ? "regular" : remainingDays > 3 ? "warn" : "alert";
  const tooltipLabel = /* @__PURE__ */ import_react16.default.createElement(TooltipLabel, null, "Trial expires on ", (0, import_legacy_components15.format)(expirationDate, "MM/DD/YYYY"), ".", " ", !isWebInstalled ? `Install the Appcues SDK to extend your trial another ${lengthDays} days.` : "");
  return /* @__PURE__ */ import_react16.default.createElement(TrialByDaysWrapper, {
    className
  }, /* @__PURE__ */ import_react16.default.createElement(import_legacy_components15.Tooltip, {
    placement: "right",
    label: tooltipLabel,
    delay: 0,
    timeout: 0
  }, /* @__PURE__ */ import_react16.default.createElement(ProgressBarWrapper, null, /* @__PURE__ */ import_react16.default.createElement(Counter, null, `${remainingDays} ${(0, import_pluralize.default)(
    "day",
    remainingDays
  )} left in trial`), /* @__PURE__ */ import_react16.default.createElement(import_legacy_components15.TrialProgressBar, {
    value: percentage,
    $status: progressBarStatus,
    $height: "large"
  }))), /* @__PURE__ */ import_react16.default.createElement(Link2, {
    to: "/subscription"
  }, "Upgrade now"));
};
TrialMeterByDays.propTypes = {
  account: import_prop_types14.default.shape({
    stripePlanId: import_prop_types14.default.string
  }),
  className: import_prop_types14.default.string,
  trialStatus: import_prop_types14.default.shape({
    expirationDate: import_prop_types14.default.oneOfType([import_prop_types14.default.number, import_prop_types14.default.string]),
    createdAt: import_prop_types14.default.oneOfType([import_prop_types14.default.number, import_prop_types14.default.string]),
    isExpired: import_prop_types14.default.bool,
    isWebInstalled: import_prop_types14.default.bool,
    lengthDays: import_prop_types14.default.number
  }),
  Link: import_prop_types14.default.oneOfType([
    import_prop_types14.default.element,
    import_prop_types14.default.object,
    import_prop_types14.default.func
  ])
};
var TrialMeterByDays_default = TrialMeterByDays;

// src/NavItem.js
var import_react17 = __toESM(require("react"));
var import_prop_types15 = __toESM(require("prop-types"));
var NavItem = ({ icon, label, to, NavLink, ...unhandledProps }) => /* @__PURE__ */ import_react17.default.createElement(NavItemWrapper, null, /* @__PURE__ */ import_react17.default.createElement(ItemLink, {
  to,
  as: NavLink,
  ...unhandledProps
}, /* @__PURE__ */ import_react17.default.createElement(IconWrapper, null, typeof icon === "string" ? /* @__PURE__ */ import_react17.default.createElement(ItemIcon, {
  icon
}) : icon), label));
NavItem.propTypes = {
  icon: import_prop_types15.default.oneOfType([import_prop_types15.default.string, import_prop_types15.default.node]),
  label: import_prop_types15.default.string.isRequired,
  to: import_prop_types15.default.string,
  NavLink: import_prop_types15.default.oneOfType([import_prop_types15.default.string, import_prop_types15.default.object])
};
var UpsellNavItem = ({
  icon,
  label,
  message,
  subject,
  ...unhandledProps
}) => /* @__PURE__ */ import_react17.default.createElement(NavItemWrapper, null, /* @__PURE__ */ import_react17.default.createElement(NavBeaconLink, {
  message,
  subject,
  ...unhandledProps
}, /* @__PURE__ */ import_react17.default.createElement(IconWrapper, null, /* @__PURE__ */ import_react17.default.createElement(ItemIcon, {
  icon
})), label));
UpsellNavItem.propTypes = {
  icon: import_prop_types15.default.string.isRequired,
  label: import_prop_types15.default.string.isRequired,
  message: import_prop_types15.default.string,
  subject: import_prop_types15.default.string
};
var NavItem_default = NavItem;

// src/index.js
var import_legacy_components16 = require("@studio/legacy-components");

// src/icons/BannerIcon.js
var import_react18 = __toESM(require("react"));
var BannerIcon = () => {
  return /* @__PURE__ */ import_react18.default.createElement("svg", {
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ import_react18.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",
    fill: "var(--text-secondary)"
  }));
};
var BannerIcon_default = BannerIcon;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AccountMenu,
  AccountMenuContent,
  AccountMenuItem,
  AccountMenuTrigger,
  BannerIcon,
  BeaconLink,
  CallToActions,
  CaretIcon,
  Counter,
  Divider,
  GearIcon,
  Group,
  Header,
  HelpMenu,
  IconWrapper,
  InstallButton,
  InstallWrapper,
  ItemIcon,
  ItemLink,
  Links,
  Logo,
  NavBeaconLink,
  NavItem,
  NavItemWrapper,
  PopoverHelpMenu,
  ProgressBarWrapper,
  Scrollable,
  SpoofBanner,
  SpoofControl,
  SpoofForm,
  SpoofFormField,
  TooltipLabel,
  TrialByDaysWrapper,
  TrialMessage,
  TrialMeterByDays,
  TrialWrapper,
  UpsellNavItem,
  Wrapper
});
//# sourceMappingURL=index.js.map